import { Route, Routes } from "react-router-dom";
import { CurrentPricesRoute, FuturePricesRoute, SubCategory, SubFutureCategory } from "./routes";
import SubCategoryCurrentPrices from "../view/SubCategoryCurrentPrices";
import SubCategoryFuturePrices from "../view/SubCategoryFuturePrices";
import FuturePrices from "../view/FuturePrices";
import CurrentPrices from "../view/CurrentPrices";

const Root = () => {
    return (
        <Routes>
            <Route path={SubCategory} element={<SubCategoryCurrentPrices />} />
            <Route path={SubFutureCategory} element={<SubCategoryFuturePrices />} />
            <Route path={FuturePricesRoute} element={<FuturePrices />} />
            <Route path={CurrentPricesRoute} element={<CurrentPrices />} />
        </Routes>
    );
};

export default Root;